import React from 'react';
import { Card, Empty, Tag } from 'antd';
import Chart from 'react-apexcharts';
import { DatabaseOutlined } from '@ant-design/icons';

const RAMChart = ({ servidor, height = 300 }) => {
  if (!servidor?.datos?.length) {
    return <Card title={servidor?.nombre || 'Sin datos'}><Empty description="No hay datos de RAM disponibles" /></Card>;
  }

  const labels = servidor.datos.map(d => new Date(d.timestamp).getTime());
  const usadoData = servidor.datos.map(d => d.usado_mb);
  const totalData = servidor.datos.map(d => d.total_mb);
  const porcentajeData = servidor.datos.map(d => d.porcentaje);

  const ramPromedio = (porcentajeData.reduce((a, b) => a + b, 0) / porcentajeData.length).toFixed(2);
  const ramMaximo = Math.max(...porcentajeData).toFixed(2);
  const totalMB = servidor.datos[0]?.total_mb || 0;

  const getColor = (ram) => {
    if (ram < 70) return { line: '#10b759', status: 'Óptimo', tag: 'green' };
    if (ram < 90) return { line: '#fd7e14', status: 'Moderado', tag: 'orange' };
    return { line: '#dc3545', status: 'Crítico', tag: 'red' };
  };
  const cs = getColor(parseFloat(ramPromedio));

  return (
    <Card
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <span><DatabaseOutlined style={{ marginRight: 8 }} />{servidor.nombre}{servidor.ip && <span style={{ fontSize: 12, color: '#888', marginLeft: 8 }}>({servidor.ip})</span>}</span>
          <span style={{ fontSize: 12, fontWeight: 'normal' }}>
            <Tag color={cs.tag}>{cs.status}</Tag>
            Total: {(totalMB / 1024).toFixed(1)}GB · Promedio: {ramPromedio}% · Pico: {ramMaximo}%
          </span>
        </div>
      }
      style={{ marginBottom: 16 }}
    >
      <Chart
        type="area"
        height={height}
        options={{
          chart: { toolbar: { show: false }, zoom: { enabled: true } },
          stroke: { width: [2, 1], curve: 'smooth', dashArray: [0, 5] },
          colors: [cs.line, '#3b82f6'],
          fill: { type: ['gradient', 'solid'], gradient: { opacityFrom: 0.3, opacityTo: 0.05 } },
          xaxis: { type: 'datetime', categories: labels, labels: { datetimeFormatter: { hour: 'HH:mm', day: 'dd/MM' } } },
          yaxis: { title: { text: 'RAM (MB)' }, labels: { formatter: v => `${Math.round(v)} MB` } },
          grid: { borderColor: '#e5e9f2', strokeDashArray: 3 },
          tooltip: {
            x: { format: 'dd/MM HH:mm' },
            y: { formatter: (v, { seriesIndex, dataPointIndex }) => {
              if (seriesIndex === 0) return `${Math.round(v)} MB (${porcentajeData[dataPointIndex]?.toFixed(1)}%)`;
              return `${Math.round(v)} MB`;
            }},
          },
          legend: { position: 'top' },
          dataLabels: { enabled: false },
        }}
        series={[
          { name: 'RAM Usado', data: usadoData },
          { name: 'RAM Total', data: totalData },
        ]}
      />
    </Card>
  );
};

export default RAMChart;
